<template>
  <div class="d3-mp4-player-container">
    <video ref="player" class="d3-mp4-player-main" :src="hasSignedCookie ? content.data.originalS3Url : null"
           controls playsinline></video>
    <div v-if="!hasSignedCookie" class="d3-mp4-player-loading mdl-spinner mdl-js-spinner is-active"></div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {GET_SIGNED_COOKIE} from '../../store/types';

  export default{
    props: ['content'],

    computed: {
      ...mapGetters(['hasSignedCookie'])
    },

    created(){
      // Signed Cookieをゲットする
      this.$store.dispatch(GET_SIGNED_COOKIE, {content: this.content});
    },

    mounted(){
      // すぐに再生開始
      this.$refs.player.play();
    },

    components: {}
  };
</script>

<style lang="scss" scoped>
  @import "../../global-variables";

  .d3-mp4-player-container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;

    .d3-mp4-player-loading {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -14px;
      z-index: 1;
    }
  }

  .d3-mp4-player-main {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    object-fit: contain;
    width: 100%;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// Mp4Player.vue?2fa71065